import React from 'react'
import Typography from '@material-ui/core/Typography';
import {theme} from "../../../shared/theme";

const TabLabel = (props) => {
    return (
    <Typography variant="subtitle1">
        {props.title} {props.subtitle !== "" ? <Typography variant="caption" style={{paddingLeft: theme.spacing(2)}}>{props.subtitle}</Typography> : null}
    </Typography>);
}

TabLabel.defaultProps = {
    subtitle: ""
};

export default TabLabel;